import { render, staticRenderFns } from "./RedirectorsMenu.vue?vue&type=template&id=01fe8d84&scoped=true&"
import script from "./RedirectorsMenu.vue?vue&type=script&lang=js&"
export * from "./RedirectorsMenu.vue?vue&type=script&lang=js&"
import style0 from "./RedirectorsMenu.vue?vue&type=style&index=0&id=01fe8d84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe8d84",
  null
  
)

export default component.exports